//#region components/mode_island/mode_island_constants.js
var e = {
	INVERTED: "inverted",
	LIGHT: "light",
	DARK: "dark"
}, t = { DT_MODE_ISLAND_TYPES: e };
//#endregion
export { e as DT_MODE_ISLAND_TYPES, t as default };

//# sourceMappingURL=mode-island-constants.js.map